import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMultiAccount, selectAccount } from '../../apis/authentication';
import { setCookie } from '../../helpers/cookies';
import { updateAuthHeaders } from '../../apis/baseApi';

export const fetchAccounts = createAsyncThunk(
  'multiAccount/fetchAccounts',
  async (state: string, { rejectWithValue }) => {
    try {
      const response = await getMultiAccount(state);
      // Some OAuth flows return a provisional access token with the account
      // list. Persist it before the account-selection request so the next
      // request is authenticated instead of racing with an empty cookie.
      if (response.data?.access_token) {
        setCookie('x-access-token', response.data.access_token);
        updateAuthHeaders();
      }
      return response.data.accounts;
    } catch (error) {
      return rejectWithValue('Failed to fetch accounts');
    }
  }
);


export const selectOrganization = createAsyncThunk(
  'multiAccount/selectOrganization',
  async ({ state, organizationId }: { state: string; organizationId: string }, { rejectWithValue }) => {
    try {
      const response = await selectAccount(state, organizationId);
      if (response.status === 200) {
        return response.data.access_token;
      }
      throw new Error('Failed to select account');
    } catch (error) {
      return rejectWithValue('Failed to select organization');
    }
  }
);
